import { useCallback, useEffect, useState } from 'react';

export const ROW_DENSITIES = ['comfortable', 'compact'];
export const DEFAULT_ROW_DENSITY = 'comfortable';

export const rowDensityKey = collectionId => `keepr.items.density.${collectionId || ''}`;

/** The stored density for a collection, or the default when none is stored (or storage is unavailable). */
export function readRowDensity(collectionId) {
	try {
		const stored = window.localStorage.getItem(rowDensityKey(collectionId));
		return ROW_DENSITIES.includes(stored) ? stored : DEFAULT_ROW_DENSITY;
	} catch {
		return DEFAULT_ROW_DENSITY;
	}
}

/**
 * ROW DENSITY on the items page (KPR-1633): comfortable or compact, one
 * choice per collection, remembered in this browser the way the view mode is
 * (utils/itemsView.js localItemsViewStore). A per-viewer convenience, so a
 * storage failure only means the choice is not remembered.
 */
export default function useRowDensity(collectionId) {
	const [density, setDensityState] = useState(() => readRowDensity(collectionId));

	// Another collection has its own choice.
	useEffect(() => {
		setDensityState(readRowDensity(collectionId));
	}, [collectionId]);

	const setDensity = useCallback(next => {
		if (!ROW_DENSITIES.includes(next)) return;
		setDensityState(next);
		try {
			window.localStorage.setItem(rowDensityKey(collectionId), next);
		} catch { /* per-viewer convenience only */ }
	}, [collectionId]);

	return [density, setDensity];
}
